import { Link } from "react-router-dom";
import { Wordmark } from "./Header";

export default function Footer() {
  return (
    <footer className="bg-warm border-t border-ink/[0.07]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <div className="flex flex-col items-center text-center mb-14">
          <Wordmark size="lg" />
          <p className="mt-6 text-sm leading-relaxed text-ink-soft max-w-md">
            Gentle, evidence-informed sleep support for babies and toddlers — nurturing, practical and tailored to your family. No cry-it-out, no judgement.
          </p>
          <a href="mailto:hello@thenannysleepco.com.au" data-testid="footer-email" className="mt-4 inline-block text-sm font-semibold text-terra hover:text-terra-hover transition-colors">
            hello@thenannysleepco.com.au
          </a>
        </div>
        <div className="grid gap-10 sm:grid-cols-2 max-w-2xl mx-auto text-center sm:text-left">
          <nav aria-label="Footer" className="text-sm space-y-3">
            <p className="overline-label mb-4">Explore</p>
            {[
              ["/start-here", "Start Here"],
              ["/sleep-assessment", "Free Sleep Assessment"],
              ["/support-options", "Support Options"],
              ["/how-i-work", "How I Work"],
              ["/sleep-help", "Sleep Help"],
              ["/parent-stories", "Parent Stories"],
              ["/about", "About"],
              ["/book-a-call", "Book a Free Call"],
            ].map(([to, label]) => (
              <Link key={to} to={to} data-testid={`footer-${label.toLowerCase().replace(/\s+/g, "-")}`} className="block text-ink-soft hover:text-terra transition-colors">
                {label}
              </Link>
            ))}
          </nav>
          <div className="text-sm space-y-3">
            <p className="overline-label mb-4">Good to know</p>
            <Link to="/privacy-terms" data-testid="footer-privacy-terms" className="block text-ink-soft hover:text-terra transition-colors">Privacy & Terms</Link>
            <p className="text-ink-muted leading-relaxed pt-2">
              Support hours: Monday–Saturday, 8am–6pm. Sleep consulting is behavioural and routine-based guidance — it is not medical advice and never replaces your GP or child health nurse.
            </p>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-ink/[0.08] flex flex-col sm:flex-row gap-3 justify-between text-xs text-ink-muted">
          <p>© {new Date().getFullYear()} The Nanny Sleep Co. All rights reserved.</p>
          <p>Every child and family is different — no specific sleep outcome is guaranteed.</p>
        </div>
      </div>
    </footer>
  );
}
